import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'gigabyte'
})
export class GigabytePipe implements PipeTransform {

    transform(value: number): string {
        if (value >= 1) {
            return `${value.toFixed(0)} GB`;
        } else {
            return `${(value * 1000).toFixed(0)} MB`;
        }
    }

}